// The default broker's display name, for every label that used to say "Kite" / "Zerodha".
//
//   brokerName()      plain function — for strings built at click time (window.confirm, titles)
//   useBrokerName()   hook — re-renders the component when the default broker changes
//   <BrokerName />    the same, as JSX text
//
// Loaded once per session from GET /brokers; BrokerPanel calls refreshBrokerInfo() after a switch.
import { useEffect, useState } from "react";
import { fetchBrokers } from "./api";

const SHORT = { KITE: "Kite", MSTOCK: "m.Stock", DHAN: "Dhan" };
let current = { name: "KITE", label: "Zerodha Kite", short: "Kite" };
let loaded = false;
let inflight = null;
const listeners = new Set();

export const brokerName = () => current.short;
export const brokerInfo = () => current;
// Short name for any broker code ("DHAN" -> "Dhan"), for copy about a broker that is not the default.
export const brokerShortName = (name, label) => SHORT[name] || label || name;

export function refreshBrokerInfo() {
  if (!inflight) {
    inflight = fetchBrokers()
      .then((r) => {
        const b = (r.data?.brokers || []).find((x) => x.is_default);
        if (b) current = { name: b.name, label: b.label, short: SHORT[b.name] || b.label };
        loaded = true;
        listeners.forEach((fn) => fn());
      })
      .catch(() => { /* older backend without /brokers: keep "Kite" */ })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useBrokerName() {
  const [, bump] = useState(0);
  useEffect(() => {
    const fn = () => bump((n) => n + 1);
    listeners.add(fn);
    if (!loaded) refreshBrokerInfo();
    return () => listeners.delete(fn);
  }, []);
  return current.short;
}

export function BrokerName() {
  return useBrokerName();
}
